import styled from 'styled-components';

export const Container = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  padding: 0 15px;
`;
